import * as SearchableSelectPrimitive from 'components/select/searchable-select';
import {
    SearchableSelectProps,
    UseFormSearchableSelect,
} from 'components/select/searchable-select';
import { SelectAllListItem } from 'components/select/select-all-list-item';
import { SelectListItem, SelectListItemIndicator } from 'components/select/select-list-item';
import { SelectListItemSeparator } from 'components/select/select-list-item-separator';

const SelectListItemMenu = SearchableSelectPrimitive.SearchableSelectListItemsContainer;
const SelectListInnerContainer = SearchableSelectPrimitive.SearchableSelectListItemsInnerContainer;
const SearchableSelect = SearchableSelectPrimitive.Root;

const ListItem = SelectListItem;
const Indicator = SelectListItemIndicator;
const AllListItem = SelectAllListItem;
const ListItemSeparator = SelectListItemSeparator;
const SearchableInput = SearchableSelectPrimitive.Input;

export {
    SelectListItem,
    SelectListItemIndicator,
    SelectAllListItem,
    SelectListItemSeparator,
    SelectListItemMenu,
    SelectListInnerContainer,
    SearchableSelect,
    //
    ListItem,
    Indicator,
    AllListItem,
    ListItemSeparator,
    SearchableInput,
    //
    UseFormSearchableSelect,
};
export type { SearchableSelectProps };
